import { AccessItem } from 'app/components/access-panel/shared/types';
import { Value } from 'app/types-shared';

export const ACTION = {
  REQUEST_LOAD_DEFAULT_VALUES: 'DEFAULT_VALUES:REQUEST_LOAD_DEFAULT_VALUES',
  RECEIVE_LOAD_DEFAULT_VALUES: 'DEFAULT_VALUES:RECEIVE_LOAD_DEFAULT_VALUES',
  FAIL_LOAD_DEFAULT_VALUES: 'DEFAULT_VALUES:FAIL_LOAD_DEFAULT_VALUES',

  REQUEST_SAVE_DEFAULT_VALUES: 'DEFAULT_VALUES:REQUEST_SAVE_DEFAULT_VALUES',
  RECEIVE_SAVE_DEFAULT_VALUES: 'DEFAULT_VALUES:RECEIVE_SAVE_DEFAULT_VALUES',
  FAIL_DEFAULT_VALUES_EXECUTE: 'DEFAULT_VALUES:FAIL_DEFAULT_VALUES_EXECUTE',

  CLEAR_VALIDATION: 'DEFAULT_VALUES:CLEAR_VALIDATION',
  PROCESS_DEFAULT_VALUES_FAILED: 'DEFAULT_VALUES:PROCESS_DEFAULT_VALUES_FAILED',
  CLEAR_DEFAULT_VALUES_DATA: 'DEFAULT_VALUES:CLEAR_DEFAULT_VALUES_DATA',

  REQUEST_ROLE: 'DEFAULT_VALUES:REQUEST_ROLE',
  RECEIVE_ROLE: 'DEFAULT_VALUES:RECEIVE_ROLE',
  FAIL_ROLE: 'DEFAULT_VALUES:FAIL_ROLE',

  UPDATE_ACCESS_DATA: 'DEFAULT_VALUES:UPDATE_ACCESS_DATA',

  REQUEST_ROLE_PANEL_ACCESS: 'DEFAULT_VALUES:REQUEST_ROLE_PANEL_ACCESS',
  RECEIVE_ROLE_PANEL_ACCESS: 'DEFAULT_VALUES:RECEIVE_ROLE_PANEL_ACCESS',
  FAIL_ROLE_PANEL_ACCESS: 'DEFAULT_VALUES:FAIL_ROLE_PANEL_ACCESS'
};

export class ClearValidation {

  public type: string = ACTION.CLEAR_VALIDATION;

  constructor(public formName: string,
    public parameters: { [key: string]: number | string }) {
  }
}

export class RequestLoadDefaultValues {
  public type: string = ACTION.REQUEST_LOAD_DEFAULT_VALUES;
}

export class ReceiveLoadDefaultValues {
  public type: string = ACTION.RECEIVE_LOAD_DEFAULT_VALUES;
  public data: any;

  constructor(data?: any) {
    this.data = data;
  }
}

export class FailLoadDefaultValues {
  public type: string = ACTION.FAIL_LOAD_DEFAULT_VALUES;
}

export class RequestSaveDefaultValues {
  public type: string = ACTION.REQUEST_SAVE_DEFAULT_VALUES;
}

export class ReceiveSaveDefaultValues {
  public type: string = ACTION.RECEIVE_SAVE_DEFAULT_VALUES;
}

export class FailDefaultValuesExecute {
  public type: string = ACTION.FAIL_DEFAULT_VALUES_EXECUTE;
}

export class ClearDefaultValuesData {
  public type: string = ACTION.CLEAR_DEFAULT_VALUES_DATA;
}

export class ProcessDefaultValuesFailed {
  public type: string = ACTION.PROCESS_DEFAULT_VALUES_FAILED;
  public errors: any;
  constructor(errors: any) {
    this.errors = errors;
  }
}

export class RequestRole {
  public type: string = ACTION.REQUEST_ROLE;
}

export class ReceiveRole {
  public type: string = ACTION.RECEIVE_ROLE;
  constructor(public data: any) {
  }
}

export class FailRole {
  public type: string = ACTION.FAIL_ROLE;
}

export class UpdateAccessData {
  public type: string = ACTION.UPDATE_ACCESS_DATA;
  public key: string;
  public accessItem: Partial<AccessItem>;

  constructor(key: string, accessItem: Partial<AccessItem>) {
    this.key = key;
    this.accessItem = accessItem;
  }
}

export class RequestRolePanelAccess {
  public type: string = ACTION.REQUEST_ROLE_PANEL_ACCESS;
}

export class ReceiveRolePanelAccess {
  public type: string = ACTION.RECEIVE_ROLE_PANEL_ACCESS;
  constructor(public values: Value[]) { }
}

export class FailRolePanelAccess {
  public type: string = ACTION.FAIL_ROLE_PANEL_ACCESS;
}
